import { render, staticRenderFns } from "./RatingReviews.vue?vue&type=template&id=e3e15d82&scoped=true"
import script from "./RatingReviews.vue?vue&type=script&lang=js"
export * from "./RatingReviews.vue?vue&type=script&lang=js"
import style0 from "./RatingReviews.vue?vue&type=style&index=0&id=e3e15d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e15d82",
  null
  
)

export default component.exports